import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

import {SharedMarkdownContent} from '@github-ui/code-view-shared/components/SharedMarkdownContent'

import {mcpDetailsRoute} from '../mcp-details-route'

import {About} from './_components/About/About'
import {Sidebar} from './_components/Sidebar/Sidebar'

import styles from './McpDetails.module.css'

export function McpDetails() {
  const payload = useRouteQuery(mcpDetailsRoute, 'mainQuery')
  const mcp = payload.data.server_data

  return (
    <div className={styles.container}>
      <div className={styles.hideOnDesktop}>
        <About mcp={mcp} />
      </div>

      <div className={styles.content}>
        <div>{mcp.readme_content ? <SharedMarkdownContent richText={mcp.readme_content} /> : null}</div>

        <Sidebar mcp={mcp} />
      </div>
    </div>
  )
}

try{ McpDetails.displayName ||= 'McpDetails' } catch {}